import React, { useEffect, useRef, useState } from "react";
import SurveyCreationMain from "../SurveyCreationMainPage/SurveyCreationMain";
import PubSub from "pubsub-js";

import { getStateLoginComplete } from "../LayoutHome/stateLogin";
import {
  CardsWrapper,
  GeneralStyle,
  SearchField,
  TableViewButton,
  useStyles,
} from "./myFormsPage.styled";

import Paper from "@material-ui/core/Paper";
import SearchIcon from "@material-ui/icons/Search";
import ViewList from "@material-ui/icons/ViewList";
import ViewCards from "@material-ui/icons/ViewModule";
import HeaderComponent from "../../components/Header/Header";
import FormList from "../../components/FormsList/FormList";
import { Form } from "react-bootstrap";
import { ReactComponent as SurveyManagementIcon } from "../../assets/svg/survey-management-icon.svg";
import { AntTab, AntTabs } from "../../helpers/antTabs";
import { Clear } from "@material-ui/icons";
import { theme as themeConfig } from "../../themes/themes";

function MyFormsPage() {
  const [selectedMenu, selectMenu] = useState([
    "assigned-form",
    "My Assigned Form",
  ]);
  const [ShowSurveyCreationMain, setShowSurveyCreationMain] = useState({
    idSurvey: 0,
    isIntegrated: false,
    isEditSurvey: false,
    dataEditSurvey: null,
    show: false,
  });

  const [user] = useState(getStateLoginComplete());
  const classes = useStyles();
  const [valueTabs, setValueTabs] = useState(0);
  const [showCards, setShowCards] = useState(true);
  const [searchTxt, setSearchTxt] = useState("");
  const rSearch = useRef();

  useEffect(() => {
    PubSub.subscribe("dataEditSurveyCreationMain", (e, data) => {
      setShowSurveyCreationMain({
        idSurvey: data.idSurvey,
        isIntegrated: false,
        isEditSurvey: true,
        show: true,
        dataEditSurvey: data?.data,
      });
    });
    return () => {
      PubSub.unsubscribe("dataEditSurveyCreationMain");
    };
  }, []);

  const getDataBySearch = () => {
    setSearchTxt(rSearch?.current?.value);
  };

  const applySearchOnBreak = () => {
    let timer;
    return function () {
      clearTimeout(timer);
      timer = setTimeout(() => {
        getDataBySearch();
      }, 500);
    };
  };

  const handleSearch = applySearchOnBreak();

  let showSelectedMenuTable = () => {
    switch (selectedMenu[0]) {
      case "assigned-form":
        return (
          <FormList
            activeMySurveys={true}
            setShowSurveyCreationMain={setShowSurveyCreationMain}
            showCards={showCards}
            setShowCards={setShowCards}
            searchBy={searchTxt}
            sortingColumns={false}
          />
        );
      case "form-history":
        return (
          <FormList
            activeMySurveys={true}
            activeMySurveysHistory={true}
            setShowSurveyCreationMain={setShowSurveyCreationMain}
            showCards={showCards}
            setShowCards={setShowCards}
            searchBy={searchTxt}
            sortingColumns={false}
          />
        );
      default:
        break;
    }
  };

  return (
    <>
      {!ShowSurveyCreationMain.show && (
        <GeneralStyle>
          <HeaderComponent
            Icon={SurveyManagementIcon}
            text={"Forms Management"}
          ></HeaderComponent>
          {user && user.roleId ? (
            <h1>{/* selectedMenu[1] */}</h1>
          ) : (
            <h1>Available Surveys</h1>
          )}
          {user && user.roleId && (
            <div className={classes.root}>
              <Paper position="static" style={{ borderRadius: "0px" }}>
                <AntTabs aria-label="My Form" value={valueTabs}>
                  <AntTab
                    label="My Assigned Forms"
                    id="assigned-form"
                    onClick={() => {
                      selectMenu(["assigned-form", "My Assigned Form"]);
                      setValueTabs(0);
                    }}
                  />
                  <AntTab
                    label="My Forms History"
                    id="form-history"
                    onClick={() => {
                      selectMenu(["form-history", "My Form History"]);
                      setValueTabs(1);
                    }}
                  />
                </AntTabs>
              </Paper>
            </div>
          )}{" "}
          <CardsWrapper className="pt-3 pb-2">
            <div className="right-section">
              <SearchField>
                <SearchIcon style={{ color: themeConfig.text.primary }} />
                <Form.Control
                  type="text"
                  placeholder="Search"
                  onChange={handleSearch}
                  ref={rSearch}
                />
                <Clear
                  style={{
                    right: "110px",
                    color: themeConfig.neutral.gray[2600],
                    width: "1rem",
                    height: "1rem",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    rSearch.current.value = "";
                    setSearchTxt("");
                  }}
                />
              </SearchField>
              <div className="table-action">
                <TableViewButton
                  iconColor={showCards}
                  onClick={() => setShowCards(false)}
                  className="MuiButtonBase-root MuiIconButton-root"
                >
                  <span
                    style={{ width: "fit-content" }}
                    className="MuiIconButton-label"
                  >
                    <ViewList className="list-view" />
                  </span>
                </TableViewButton>
                <TableViewButton
                  iconColor={showCards}
                  onClick={() => setShowCards(true)}
                  style={{ borderLeft: "none" }}
                  className="MuiButtonBase-root MuiIconButton-root"
                >
                  <span
                    style={{ width: "fit-content" }}
                    className="MuiIconButton-label"
                  >
                    <ViewCards className="card-view" />
                  </span>
                </TableViewButton>
              </div>
            </div>
          </CardsWrapper>
          {showSelectedMenuTable()}
        </GeneralStyle>
      )}

      {ShowSurveyCreationMain.show && (
        <SurveyCreationMain
          idSurvey={ShowSurveyCreationMain.idSurvey}
          isIntegrated={ShowSurveyCreationMain.isIntegrated}
          isEditSurvey={ShowSurveyCreationMain.isEditSurvey}
          dataEditSurvey={ShowSurveyCreationMain.dataEditSurvey}
        />
      )}
    </>
  );
}

export default MyFormsPage;
